var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVa = function SvgVa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF200",
    fillRule: "evenodd",
    d: "M0 12c0 6.627 5.373 12 12 12V0C5.373 0 0 5.373 0 12Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0v24Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.82 9.547a.119.119 0 0 0-.21.086.158.158 0 0 1 .08.1.119.119 0 0 0 .13-.186Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.66 9.675c-.056-.07-.145-.07-.213-.017a.24.24 0 0 0-.037.037c.043.015.08.036.119.084a.234.234 0 0 1 .055.135.25.25 0 0 0 .044-.028c.068-.054.088-.141.032-.211Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.53 9.78c-.064-.08-.158-.113-.209-.072a.092.092 0 0 0-.032.066.172.172 0 0 1 .168.063.173.173 0 0 1 .025.178.092.092 0 0 0 .07-.017c.052-.04.041-.139-.022-.219h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.457 9.838c-.054-.067-.146-.087-.214-.046.028.026.074.08.112.128.039.049.081.106.099.136.055-.057.056-.15.003-.218h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.277 9.981c-.038-.048-.083-.107-.133-.11l-.102.082c-.104.14-.15.24-.184.362.14-.006.252-.03.443-.12.109-.053.032-.143-.024-.214Zm-.515.197-.387.31c.084-.027.168-.053.247-.085.049-.07.094-.148.14-.225h0Zm.208.262c-.085.027-.17.054-.25.086-.048.07-.092.144-.137.22l.387-.306Zm-.486.174a1.007 1.007 0 0 0-.383.094l-.11.089c-.007.048.036.103.074.15.056.071.126.166.203.072.13-.166.178-.27.215-.405Zm-.593.264-.237.19a.283.283 0 0 1 .137.097.283.283 0 0 1 .065.156l.238-.188a1.427 1.427 0 0 1-.107-.123 1.418 1.418 0 0 1-.096-.132h0Zm-.169.342a.177.177 0 0 0-.122-.068.118.118 0 0 0-.075.02v-.002l-.516.414a.676.676 0 0 1 .2.25l.518-.41h-.001c.052-.047.05-.136-.004-.204Zm-.692.625h0s0 0 0 0 0 0 0 0Zm-.07-.088a.094.094 0 0 0 0 0h0Zm-.052-.05-.009.016a.151.151 0 0 0 .01-.016Zm.159.198a.22.22 0 0 0 0 0Zm-.178-.167-.004.005.004-.005Zm.007.344a.959.959 0 0 1-.199-.248h0l-.33.264c-.18.059-.415.137-.521.186-.179.081-.395.286-.429.49l.14.174.138.173c.205.012.453-.152.573-.308.07-.093.2-.305.297-.468l.331-.263Zm-.83.467c.01.06-.038.161-.14.23-.117.076-.222.128-.283.051-.06-.076.051-.17.142-.229a.38.38 0 0 1 .197-.066c.033 0 .062.005.085.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.791 11.165a.294.294 0 0 0-.123-.093c-.043-.016-.083-.013-.11.008-.023.019-.035.052-.032.092a.118.118 0 0 1 .099-.016.184.184 0 0 1 .097.064c.026.033.04.072.041.11a.12.12 0 0 1-.037.093c.039.011.073.007.097-.012a.087.087 0 0 0 .028-.043.147.147 0 0 0 .004-.062.248.248 0 0 0-.02-.071.333.333 0 0 0-.044-.07h0ZM16.406 12.76l.3.375s.046.06-.033.123c-.079.062-.126.003-.126.003l-.3-.375s-.048-.059.032-.123.127-.003.127-.003Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m16.23 12.862.337.423s.066.083-.013.146c-.08.063-.145-.02-.145-.02l-.338-.423s-.067-.082.013-.146c.08-.064.145.02.145.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.124 11.698c-.106-.132-.235-.205-.288-.163l-.002.002.003.001.009.003.005.002a.099.099 0 0 1 .02.012l.002.001a.132.132 0 0 1 .014.013l.002.002a.135.135 0 0 1 .019.023l.004.006v.002l.004.006.001.003.002.006.002.003a.11.11 0 0 1 .004.024v.001c0 .006 0 .012-.002.018 0 0 0 0 0 0a.125.125 0 0 1-.004.021s0 0 0 0a.135.135 0 0 1-.01.023s0 0 0 0a.671.671 0 0 1 .05.05.098.098 0 0 1 .023-.025.092.092 0 0 1 .055-.02c.019 0 .035.006.045.02.01.012.014.03.01.048a.098.098 0 0 1-.061.065.67.67 0 0 1 .036.06.168.168 0 0 1 .024-.004s0 0 0 0h.022s0 0 0 0a.1.1 0 0 1 .018.003s0 0 0 0a.085.085 0 0 1 .023.01l.003.001.005.004.003.002a.064.064 0 0 1 .005.004l.002.001a.314.314 0 0 1 .005.006l.002.002a.131.131 0 0 1 .01.012l.006.009.002.002a.255.255 0 0 1 .009.017v.001a.135.135 0 0 1 .008.024v.004l.002.012v.001l.002-.001c.054-.043.011-.185-.094-.317h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.082 11.73c-.021-.026-.066-.025-.1.002a.09.09 0 0 0-.034.055.09.09 0 0 0-.102.003c.114-.115.08-.178.05-.211-.028-.034-.059-.045-.083-.043-.014.002-.064 0-.074.065.034.002.05.1-.041.233a.958.958 0 0 0 .199.248c.205-.13.23-.047.224-.013.065.004.087-.018.092-.032.007-.023.003-.055-.024-.091-.026-.036-.08-.083-.217.003a.09.09 0 0 0 .026-.1.089.089 0 0 0 .061-.02c.034-.028.045-.071.023-.098Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.925 12.778c-.116.077-.221.128-.282.052-.06-.076.05-.17.141-.229.118-.076.222-.076.282-.052.01.06-.039.161-.14.229Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.6 12.874a.865.865 0 1 0-.07 1.73.865.865 0 0 0 .07-1.73h0Zm-.048.141a.722.722 0 0 1 .358.088.367.367 0 0 0-.288.124.367.367 0 0 0-.254-.185.72.72 0 0 1 .184-.027Zm-.19.174a.288.288 0 0 1 .248.15.288.288 0 1 1 .353.444.288.288 0 1 1-.443.354.287.287 0 0 1-.442-.011.288.288 0 0 1 .088-.433.288.288 0 0 1 .195-.504Zm-.433.203a.368.368 0 0 0 .125.289.367.367 0 0 0-.186.253.724.724 0 0 1 .061-.542Zm1.332.147c.052.184.03.38-.062.548a.367.367 0 0 0-.125-.291.367.367 0 0 0 .186-.256Zm-.754.71a.365.365 0 0 0 .253.185.724.724 0 0 1-.542-.061.368.368 0 0 0 .289-.124Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.764 12.949a.133.133 0 1 0 .209-.166.133.133 0 0 0-.209.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.048 12.894s.048-.038.084.008c.037.046-.01.084-.01.084l-.192.153s-.047.038-.084-.008c-.037-.047.01-.084.01-.084l.192-.153Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.24 13.2a.865.865 0 0 1-1.352 1.078c.439.55.947.566 1.32.269.374-.298.47-.798.032-1.348h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.26 13.54a.367.367 0 0 1-.186.256.368.368 0 0 1 .124.291.724.724 0 0 0 .062-.547Zm-.35-.436a.724.724 0 0 0-.542-.061.368.368 0 0 1 .254.185.366.366 0 0 1 .288-.124Zm-.98.288a.724.724 0 0 0-.062.542.367.367 0 0 1 .186-.253.368.368 0 0 1-.125-.288h0Zm.83 1.042a.367.367 0 0 1-.253-.185.364.364 0 0 1-.29.124c.167.09.361.112.543.061Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.775 14.538a.133.133 0 1 0-.166-.208.133.133 0 0 0 .166.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.72 14.255s-.038-.048.008-.084c.046-.037.084.01.084.01l.153.192s.038.047-.008.084c-.046.037-.084-.01-.084-.01l-.153-.192Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.377 14.55a.133.133 0 1 0-.208.166.133.133 0 0 0 .208-.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.097 14.604s-.047.037-.084-.009c-.037-.046.01-.084.01-.084l.192-.152s.048-.038.084.008c.037.046-.01.084-.01.084l-.192.152ZM20.282 10.327a3.041 3.041 0 0 1-.313.113l-.386.305c-.04.069-.082.137-.125.202.006.154-.007.28-.057.413l.169.223.107-.078.123.113-.124.09.123.116.079.008.404-.315-.087-.02-.235-.31-.095.084.008.113-.062.046-.263-.306.075-.067.07.058.116-.06-.062-.095-.14.002-.045-.052.295-.238.047.059-.018.104.062.076.075-.095-.034-.048.096-.076.215.277-.061.067-.079-.021-.074.069.259.271.073.018.384-.34-.114-.151-.11.093-.096-.12.111-.103-.184-.251-.144.113-.099-.121.152-.117-.037-.05Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m20.318 10.377-.152.116.099.122.06-.048-.007-.19ZM20.593 10.752l-.112.104.096.12.018-.016-.002-.208ZM20.802 11.034l-.384.34-.073-.018-.26-.272-.007.184.266.281.073.02.385-.342v-.193Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.418 11.373v.197M20.345 11.355l-.001.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m20.16 11.015.079.021.06-.068-.214-.276-.096.076.034.048-.075.095-.063-.076.019-.104-.047-.06-.296.24.045.05h.141l.096-.084.037.045-.006.112.07.094.086-.115-.003-.063.054-.047.079.112Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.874 11.034.012-.2M19.857 10.672l-.014.205M19.948 10.912l-.003.216M20.023 10.816l.004.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.703 11.305.102-.05.004-.2-.116.06-.07-.058-.075.067.155.181Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.693 11.115-.002.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.402 11.36a1.004 1.004 0 0 1-.06.132l.231.29.103-.075.124-.089-.123-.113-.107.078-.168-.223Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.57 11.583.003.2M19.677 11.505l-.011.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.677 11.708-.005.004-.006.202.128.11.084.005.402-.319.002-.193-.403.315-.079-.007-.123-.117Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.8 11.825-.006.198M19.878 11.832v.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.354 9.92a1.312 1.312 0 0 0-.111-.127l-.1.08c.05.001.095.06.134.108.056.07.133.16.024.214-.19.09-.302.114-.443.12.034-.122.08-.221.184-.362l-.28.225a3.979 3.979 0 0 1-.14.225 4.01 4.01 0 0 1-.247.086l-.274.219c.154-.066.259-.088.383-.094-.038.136-.086.24-.216.405-.077.094-.147 0-.203-.071-.037-.046-.082-.101-.078-.148l-.096.077c.023.037.054.08.096.133.14.174.205.23.297.15.174-.158.29-.422.436-.634.238-.095.522-.15.715-.284.098-.071.058-.148-.08-.322h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88D37",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.845 11.79a.09.09 0 0 1 .102-.003.08.08 0 0 1 .012-.03.693.693 0 0 0-.051-.05.35.35 0 0 1-.064.083Zm.184.055a.081.081 0 0 1-.032.004.09.09 0 0 1-.026.1.333.333 0 0 1 .095-.044.684.684 0 0 0-.037-.06Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m17.066 12.55.372-.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.617 13.34a.131.131 0 0 1 .09.05.133.133 0 0 1-.022.187.131.131 0 0 1-.098.028.135.135 0 0 1-.09-.05.133.133 0 0 1 .022-.187.135.135 0 0 1 .098-.028ZM15.845 13.636a.131.131 0 0 1 .09.05.133.133 0 0 1-.021.187.135.135 0 0 1-.148.012.134.134 0 0 1 .08-.249ZM15.557 13.873a.135.135 0 0 1 .114.095.133.133 0 1 1-.114-.095ZM15.312 13.575a.133.133 0 1 1-.03.265.133.133 0 0 1 .03-.264ZM14.344 9.547a.119.119 0 0 1 .211.086.157.157 0 0 0-.08.1.119.119 0 0 1-.131-.186Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.504 9.675c.056-.07.146-.07.213-.017a.244.244 0 0 1 .037.037.244.244 0 0 0-.119.084.233.233 0 0 0-.055.135.25.25 0 0 1-.044-.028c-.068-.054-.088-.141-.032-.211Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.634 9.78c.064-.08.158-.113.209-.072.018.015.03.038.032.066a.172.172 0 0 0-.168.063.173.173 0 0 0-.025.178.092.092 0 0 1-.07-.017c-.052-.04-.041-.139.022-.219h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.707 9.838c.054-.067.146-.087.214-.046a1.39 1.39 0 0 0-.111.128 1.504 1.504 0 0 0-.1.136c-.055-.057-.056-.15-.003-.218h0ZM14.887 9.981c.038-.048.083-.107.133-.11l.102.082c.104.14.15.24.184.362a1.047 1.047 0 0 1-.443-.12c-.109-.053-.032-.143.024-.214Zm.515.197.387.31c-.084-.027-.168-.053-.247-.085-.049-.07-.094-.148-.14-.225h0Zm-.207.262c.084.027.17.054.25.086.047.07.091.144.136.22l-.386-.306Zm.486.174c.124.006.228.028.382.094l.11.089c.007.048-.036.103-.074.15-.056.071-.126.166-.203.072a1.047 1.047 0 0 1-.216-.405Zm.592.264.237.19a.283.283 0 0 0-.137.097.283.283 0 0 0-.065.156l-.238-.188c.031-.03.066-.072.107-.123a1.4 1.4 0 0 0 .096-.132h0Zm.17.342a.177.177 0 0 1 .12-.068.118.118 0 0 1 .076.02v-.002l.516.414a.676.676 0 0 0-.2.25l-.518-.41h.001c-.051-.047-.05-.136.004-.204Zm.691.625h0s0 0 0 0 0 0 0 0Zm.07-.088a.094.094 0 0 1 .006.01l-.005-.01h0Zm.052-.05.009.016a.151.151 0 0 1-.01-.016Zm-.158.198a.222.222 0 0 1 0 0Zm.177-.167.004.005-.004-.005Zm-.007.344a.958.958 0 0 0 .199-.248h0l.33.264c.18.059.415.137.521.186.179.081.395.286.429.49l-.14.174-.138.173c-.205.012-.453-.152-.573-.308a6.585 6.585 0 0 1-.297-.468l-.331-.263Zm.83.467c-.01.06.038.161.14.23.117.076.222.128.283.051.06-.076-.051-.17-.142-.229a.379.379 0 0 0-.197-.066.223.223 0 0 0-.084.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.373 11.165a.295.295 0 0 1 .123-.093c.043-.016.083-.013.11.008.023.019.035.052.033.092a.118.118 0 0 0-.1-.016.184.184 0 0 0-.097.064.184.184 0 0 0-.041.11c-.001.038.012.07.037.093-.038.011-.073.007-.097-.012a.087.087 0 0 1-.028-.043.147.147 0 0 1-.004-.062.248.248 0 0 1 .021-.071.332.332 0 0 1 .043-.07h0ZM18.758 12.76l-.3.375s-.047.06.032.123.126.003.126.003l.3-.375s.048-.058-.032-.122-.127-.004-.127-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m18.935 12.862-.337.423s-.066.083.012.146c.08.063.146-.02.146-.02l.337-.423s.067-.082-.013-.146c-.08-.064-.145.02-.145.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.04 11.698c.106-.132.235-.205.288-.163l.002.002-.003.001a.105.105 0 0 0-.043.024s0 0 0 0a.103.103 0 0 0-.007.007l-.002.002-.007.008a.165.165 0 0 0-.01.012s0 .002-.002.003a.116.116 0 0 0-.004.006v.002a.076.076 0 0 0-.005.01l-.003.005v.003a.085.085 0 0 0-.004.024v.001a.114.114 0 0 0 .006.04s0 0 0 0 0 0 0 0a.168.168 0 0 0 .01.023.692.692 0 0 0-.052.049.096.096 0 0 0-.077-.046.056.056 0 0 0-.045.02.056.056 0 0 0-.01.049.096.096 0 0 0 .061.065.671.671 0 0 0-.036.06.166.166 0 0 0-.024-.004s0 0 0 0h-.022s0 0 0 0a.1.1 0 0 0-.018.003s0 0 0 0a.082.082 0 0 0-.023.01l-.003.001-.005.004-.003.002-.005.004-.002.001a.153.153 0 0 0-.005.006l-.002.002-.003.004a.105.105 0 0 0-.013.017l-.002.002a.105.105 0 0 0-.009.017v.001l-.004.008a.113.113 0 0 0-.004.016v.004l-.002.012v.001l-.002-.001c-.054-.043-.011-.185.094-.317h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.082 11.73c.021-.026.066-.025.1.002a.09.09 0 0 1 .034.055.09.09 0 0 1 .103.003c-.115-.115-.08-.178-.051-.211.028-.034.059-.045.083-.043.015.002.064 0 .074.065-.034.002-.05.1.041.233a.958.958 0 0 1-.199.248c-.204-.13-.23-.047-.223-.013-.066.004-.088-.018-.093-.032-.007-.023-.003-.055.024-.091.026-.036.08-.083.217.003a.09.09 0 0 1-.026-.1.09.09 0 0 1-.061-.02c-.034-.028-.044-.071-.023-.098Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.239 12.778c.116.077.221.128.282.052.06-.076-.05-.17-.141-.229-.118-.076-.222-.076-.282-.052-.01.06.039.161.14.229Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.564 12.874a.865.865 0 1 1 .07 1.729.865.865 0 0 1-.07-1.73h0Zm.048.141a.723.723 0 0 0-.358.088.367.367 0 0 1 .288.124.368.368 0 0 1 .254-.185.72.72 0 0 0-.184-.027Zm.19.174a.288.288 0 0 0-.247.15.288.288 0 1 0-.353.444.288.288 0 1 0 .443.354.288.288 0 1 0 .353-.444.288.288 0 0 0-.195-.504Zm.433.203a.367.367 0 0 1-.125.289.364.364 0 0 1 .186.253.724.724 0 0 0-.061-.542Zm-1.331.147a.724.724 0 0 0 .061.548.368.368 0 0 1 .125-.291.367.367 0 0 1-.186-.256Zm.753.71a.368.368 0 0 1-.253.185c.182.05.376.029.542-.061a.368.368 0 0 1-.289-.124Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.4 12.949a.133.133 0 1 1-.209-.167.133.133 0 0 1 .209.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.116 12.894s-.048-.038-.084.008c-.037.046.01.084.01.084l.192.153s.047.038.084-.008c.037-.047-.01-.084-.01-.084l-.192-.153Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.924 13.2a.865.865 0 0 0 1.352 1.078c-.439.55-.947.566-1.32.269-.374-.298-.47-.798-.032-1.348h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.904 13.54a.367.367 0 0 0 .186.256.366.366 0 0 0-.124.291.724.724 0 0 1-.062-.547Zm.35-.436a.724.724 0 0 1 .542-.061.368.368 0 0 0-.254.185.365.365 0 0 0-.288-.124Zm.981.288c.09.166.112.36.061.542a.367.367 0 0 0-.186-.253.366.366 0 0 0 .125-.289h0Zm-.83 1.042a.367.367 0 0 0 .252-.185.37.37 0 0 0 .29.124.724.724 0 0 1-.543.061Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.389 14.538a.133.133 0 1 1 .166-.208.133.133 0 0 1-.166.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M20.444 14.255s.038-.048-.008-.084c-.046-.037-.084.01-.084.01l-.153.192s-.038.047.008.084c.046.037.084-.01.084-.01l.153-.192Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.787 14.55a.133.133 0 1 1 .208.166.133.133 0 0 1-.208-.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.067 14.604s.047.037.084-.009c.037-.046-.01-.084-.01-.084l-.192-.152s-.048-.038-.084.008c-.037.046.01.084.01.084l.192.152ZM14.883 10.327l-.037.05.152.116-.099.121-.144-.113-.184.25.111.104-.095.12-.111-.093-.114.152.384.339.073-.018.26-.271-.075-.07-.079.022-.061-.067.215-.277.096.076-.034.048.075.095.063-.076-.019-.104.047-.06.295.24-.044.05h-.141l-.062.094.116.06.07-.058.075.067-.263.306-.062-.046.008-.113-.095-.083-.235.308-.086.02.403.316.079-.008.123-.117-.124-.089.123-.113.107.078.17-.223a1.033 1.033 0 0 1-.057-.412 4.494 4.494 0 0 1-.126-.203l-.386-.305a3.03 3.03 0 0 1-.312-.113h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m14.846 10.377.152.116-.098.122-.061-.048.007-.19ZM14.571 10.752l.112.104-.096.12-.018-.016.002-.208ZM14.362 11.034l.385.34.072-.018.26-.272.007.184-.266.281-.073.02-.384-.342v-.193Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.746 11.373v.197M14.82 11.355v.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.004 11.015-.079.021-.06-.068.214-.276.096.076-.034.048.075.095.063-.076-.019-.104.047-.06.295.24-.044.05h-.141l-.095-.084-.038.045.006.112-.07.094-.086-.115.003-.063-.054-.047-.079.112Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.29 11.034-.012-.2M15.307 10.672l.014.205M15.216 10.912l.003.216M15.14 10.816l-.003.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.46 11.305-.101-.05-.004-.2.116.06.07-.058.075.067-.155.181Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.47 11.115.003.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.762 11.36-.169.223-.107-.078-.123.113.124.09.103.075.233-.292a.99.99 0 0 1-.06-.131Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.594 11.583-.003.2M15.487 11.505l.011.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.487 11.708.005.004.006.202-.128.11-.084.005-.402-.319-.002-.193.403.315.08-.007.122-.117Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.364 11.825.006.198M15.286 11.832v.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M14.81 9.92c.043-.055.08-.097.111-.127l.1.08c-.05.001-.095.06-.134.108-.056.07-.133.16-.024.214.19.09.303.114.443.12a1.015 1.015 0 0 0-.184-.362l.28.225c.045.077.091.154.14.225.08.032.163.059.248.086l.273.219a1.006 1.006 0 0 0-.382-.094c.037.136.085.24.215.405.077.094.147 0 .203-.071.037-.046.082-.101.078-.148l.096.077c-.023.037-.054.08-.096.133-.14.174-.205.23-.297.15-.174-.158-.29-.422-.436-.634-.238-.095-.522-.15-.715-.284-.098-.071-.058-.148.08-.322h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515356",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.32 11.79a.09.09 0 0 0-.103-.003.08.08 0 0 0-.012-.03.693.693 0 0 1 .051-.05.35.35 0 0 0 .064.083Zm-.185.055a.08.08 0 0 0 .032.004.09.09 0 0 0 .026.1.333.333 0 0 0-.095-.044.682.682 0 0 1 .037-.06Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m18.098 12.55-.372-.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBEC0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.547 13.34a.132.132 0 0 0-.113.096.133.133 0 1 0 .113-.096ZM19.319 13.636a.132.132 0 0 0-.09.05.135.135 0 0 0-.012.147.134.134 0 0 0 .233-.129.134.134 0 0 0-.131-.068ZM19.607 13.873a.135.135 0 0 0-.09.05.135.135 0 0 0-.012.147.134.134 0 0 0 .25-.08.132.132 0 0 0-.05-.089.135.135 0 0 0-.098-.028ZM19.852 13.575a.134.134 0 0 0-.113.096.134.134 0 0 0 .143.17.134.134 0 0 0-.03-.265Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.581 10.327c.362 0 .655-.056.655-.124 0-.07-.293-.125-.655-.125-.361 0-.654.056-.654.125 0 .068.293.124.654.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.582 7.846c-.226 0-.428.15-.565.384.009.027.032.066.052.08.036.026.026.104-.016.163-.026.037-.026.039.077-.006.062-.027.076-.063.055-.108-.065-.079-.04-.12-.001-.133.038-.014.075.008.062.119a.113.113 0 0 0 .038.072c.068.064.153.065.194.025.047-.044.077-.054.01-.054-.052 0-.068-.043-.1-.13.09-.001.058-.146.14-.099-.031-.129.025-.147.054-.195.03.048.086.066.054.195.082-.047.05.098.14.098-.032.088-.048.13-.1.13-.066 0-.037.01.01.055.041.04.126.04.194-.025a.112.112 0 0 0 .039-.072c-.014-.111.023-.133.062-.12.038.014.064.055-.001.134-.022.045-.007.081.055.108.103.045.102.043.076.006-.042-.059-.051-.137-.016-.162a.197.197 0 0 0 .053-.08c-.138-.236-.34-.385-.566-.385ZM17.697 8.824c.016.032.027.08.079.08-.032.088-.048.13-.1.13-.066 0-.062.01-.015.055.041.04.194.04.262-.025A.114.114 0 0 0 17.96 9c-.021-.11.02-.136.06-.125.04.01.07.046.013.139-.005.041.041.075.1.1.103.046.113.048.086-.005-.019-.041-.017-.08-.006-.093a.717.717 0 0 1 .057-.059c.015-.013.035-.003.044.003l.095.055c.004.003.023.016.033.005a.19.19 0 0 0 .018-.03v-.003l-.005-.012c-.06-.126-.424-.147-.758-.15Zm-.23 0c-.347.003-.727.025-.763.165a.184.184 0 0 0 .019.03c.009.01.028-.002.033-.005l.094-.055c.009-.006.03-.016.044-.003a.7.7 0 0 1 .057.059c.01.014.013.052-.006.093-.026.053-.017.05.086.006.06-.026.105-.06.1-.101-.056-.093-.027-.128.013-.139.04-.01.082.015.06.125a.115.115 0 0 0 .038.065c.067.064.22.065.262.025.046-.044.05-.055-.016-.055-.052 0-.068-.042-.1-.13.053 0 .064-.048.08-.08ZM17.52 9.396a3.243 3.243 0 0 0-.8.128c.01.032-.034.066-.047.078.039.021.083.066.137.01.044-.046.092-.026.118-.007.023.016.065.054.048.125-.013.052.001.062.113-.004.021-.012.058-.052.044-.092-.065-.079-.036-.112.005-.12.041-.009.075-.003.056.106.003.025.022.043.047.067.068.064.177.074.237.035.055-.035.098-.05.031-.05-.051 0-.103-.048-.134-.136.089 0 .07-.144.153-.097a.324.324 0 0 1-.008-.043Zm.123 0a.322.322 0 0 1-.007.043c.082-.047.064.096.153.097-.031.088-.083.135-.134.135-.067 0-.024.016.03.051.06.04.17.029.238-.035.025-.024.044-.042.047-.067-.019-.109.014-.115.056-.106.04.008.07.041.005.12-.014.04.023.08.044.092.111.066.126.056.113.004-.017-.071.025-.109.048-.125.026-.02.073-.038.118.007.054.056.098.011.137-.01-.013-.012-.057-.046-.047-.078a3.245 3.245 0 0 0-.8-.128ZM18.066 10.336a2.041 2.041 0 0 1-.319.044c.069.275.23.735.41.975.012.016.033.037.05.056l-.01.008.008.008.245-.196-.017-.02c-.187-.242-.29-.624-.367-.875Zm.65 1.097-.253.2c.074.048.15.084.218.093.014 0 .026 0 .04-.002.136-.011.183-.124.206-.27a.434.434 0 0 1-.212-.021Zm-.035.293h-.003.006-.003Zm0 0h-.006l.022.002h-.005l-.01-.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.681 11.726a.556.556 0 0 1-.218-.093l.252-.2a.434.434 0 0 0 .212.021c-.023.146-.07.259-.206.27-.014.002-.026.001-.04.002Zm0 0h-.003.003m0 0h.003-.003m0 0h-.006l.022.002h0-.005l-.01-.002Zm-.615-1.39a2.041 2.041 0 0 1-.319.044c.069.275.23.735.41.975.012.016.033.037.05.056l-.01.008.008.008.245-.196-.017-.02c-.187-.242-.29-.624-.367-.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19 9.128c-.096-.013-.132.135-.145.265-.015.147.082.895.094 1.013.014.146.07.596.068.9-.002.29-.101.402-.266.42.014-.002.028-.003.04-.006.37-.027.423-.153.495-.276.098-.191.127-.484.071-1.02-.014-.13-.097-.811-.14-1.148a1.304 1.304 0 0 0-.17-.131.132.132 0 0 0-.046-.017Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.249 8.721c-.12.043-.378.378-.378.378h.002a.124.124 0 0 1 .108-.046c.02.002.042.008.066.017.063.026.35.275.536.44h0l.301-.297c-.162-.208-.416-.48-.635-.492Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.1 10.336c-.077.252-.181.633-.368.876l-.017.02.245.196.007-.008-.01-.008c.018-.02.04-.04.052-.057.18-.24.34-.7.41-.975h.009a1.906 1.906 0 0 1-.328-.044Zm-.65 1.097a.433.433 0 0 1-.212.021l.001.006a.878.878 0 0 0 .017.079l.001.005c.02.07.051.125.104.155l.006.004a.216.216 0 0 0 .02.009c.017.006.036.01.057.012.014.002.027.001.04.001a.555.555 0 0 0 .218-.091l-.253-.2Zm.034.292h-.003.006-.003Zm0 0-.01.002-.006.001.022-.002h-.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.484 11.725h-.04a.216.216 0 0 1-.058-.013s0 0 0 0l-.019-.01-.006-.002s0 0 0 0c-.053-.03-.084-.086-.104-.156l-.001-.005a.736.736 0 0 1-.017-.079v-.006c.072.01.142.003.21-.02l.253.2a.555.555 0 0 1-.218.091Zm0 0h-.003.003m0 0h.003-.003m0 0-.01.002-.006.001h0l.022-.002h-.006Zm.616-1.389c-.077.252-.181.633-.368.876l-.017.02.245.196.007-.008-.01-.008c.018-.02.04-.04.052-.057.18-.24.34-.7.41-.975h.009a1.906 1.906 0 0 1-.328-.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.163 9.128a.134.134 0 0 0-.045.017 1.49 1.49 0 0 0-.17.123c-.043.337-.127 1.026-.14 1.156-.056.536-.027.829.07 1.02.073.123.125.249.495.277l.04.005c-.165-.018-.264-.13-.266-.42-.002-.304.054-.754.068-.9.012-.118.11-.865.095-1.013-.013-.13-.05-.278-.146-.265Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.917 8.721c-.22.013-.483.274-.646.482l.296.292c.186-.165.489-.4.552-.425a.226.226 0 0 1 .066-.017.124.124 0 0 1 .108.046h.001s-.257-.335-.377-.378Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.198 9.132.448.442s.022.021-.01.054c-.031.032-.053.01-.053.01l-.448-.441s-.022-.022.01-.054.053-.01.053-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    d: "m15.477 9.534-.24.276.003.061.092-.028.204-.25-.059-.06Zm-.044-.044-.23.267-.01.056.044-.003.24-.276-.044-.044Zm-.046-.045-.221.252-.003.058.04.002.23-.267-.046-.045Zm-.038-.038-.237.234-.004.056h.058l.22-.252-.037-.038Zm-.04-.039-.245.181.006.034-.009.046.051.012.237-.234-.04-.039Zm-.037-.037-.22.183-.022.048.034-.013.245-.18-.037-.038Zm-.035-.034.035.034-.207.173-.097-.002.049-.063.22-.142Zm-.035-.035-.257.114-.013.066.085-.002.22-.143-.035-.035Zm-.03-.03-.233.068-.04.07.046.006.257-.114-.03-.03Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.477 9.534-.24.276m.24-.276.06.058-.205.25-.092.03-.003-.062m.24-.276-.044-.044m-.196.32-.045.003.011-.056m.23-.267-.23.267m.23-.267-.046-.045m-.184.312-.04-.002.003-.058m.22-.252-.22.252m.22-.252-.037-.038m-.183.29h-.058l.004-.056m.237-.234-.237.234m.237-.234-.04-.039m-.197.273-.05-.012.008-.046-.006-.034m.245-.18-.245.18m.245-.18-.037-.038m-.208.218-.034.013.022-.048.22-.183m0 0-.035-.034m.035.034-.207.173-.097-.002.049-.063m.22-.142-.22.143m.22-.143-.035-.035m-.185.178-.085.002.013-.066m.257-.114-.257.114m.257-.114-.03-.03-.233.068-.04.07.046.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.993 10.083.012.109-.11-.039-.016.133.116-.011-.04.117.133.017-.01-.124.11.039.016-.133-.116.011.038-.103-.133-.016ZM17.074 10.774l-.015.09-.079-.057-.044.103.096.017-.06.085.103.043.02-.1.079.056.043-.102-.095-.018.054-.073-.102-.043ZM15.867 8.87l-.066.088-.053-.104-.103.086.092.071-.11.059.085.103.078-.097.053.104.104-.086-.093-.072.098-.048-.085-.103Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.184 9.053a.226.226 0 0 0-.066.017c-.063.026-.365.26-.552.425l.052.05c.028-.022.375-.33.5-.4.132-.073.177.1.192.248.014.147-.083.895-.095 1.013-.014.146-.07.596-.068.9.002.309.114.417.298.424.012 0 .026-.003.039-.005h-.04c-.171-.015-.203-.19-.22-.389-.008-.08.07-.823.084-.97.015-.148.058-.515.08-.734.026-.238-.015-.387-.062-.481-.034-.071-.081-.103-.142-.098h0Zm.3 2.672a.506.506 0 0 0 .26-.06l-.04-.033a.562.562 0 0 1-.22.093Zm.934-1.345c-.07.274-.23.734-.41.975-.012.016-.034.037-.05.057l.045.038c.012-.014.024-.023.037-.037.178-.2.356-.685.445-1.03a.863.863 0 0 1-.067-.003ZM15.818 8.709c-.219.002-.451.271-.603.439l.056.055c.162-.208.426-.47.645-.482a.373.373 0 0 0-.098-.012Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.865 9.336c-.048.406-.114.858-.127 1.072-.032.536-.088.767.102 1.107.103.183.243.24.605.215a.386.386 0 0 1-.071-.01c-.37-.027-.422-.153-.495-.276-.097-.191-.126-.484-.07-1.02.013-.13.097-.816.14-1.156a3.382 3.382 0 0 0-.083.068h0Zm.614 2.39-.03.003c.015 0 .028 0 .043-.002l-.013-.001Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.032 10.317c-.118.385-.242.718-.37.873l.053.042.017-.02c.187-.243.291-.624.368-.876-.024-.004-.046-.014-.068-.019Zm-.674 1.104a.339.339 0 0 1-.125.005l.004.028a.432.432 0 0 0 .212-.02l-.012-.01s0 0 0 0h0a.115.115 0 0 1-.08-.003v0ZM19.966 9.132l-.448.442s-.022.021.01.053c.032.033.053.011.053.011l.448-.441s.022-.022-.01-.054-.053-.01-.053-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    d: "m19.687 9.534.24.276-.003.061-.092-.028-.204-.251.059-.058Zm.044-.044.23.267.01.056-.044-.003-.24-.276.044-.044Zm.046-.046.221.253.003.058-.04.002-.23-.267.046-.046Zm.038-.037.237.234.004.056h-.058l-.22-.253.037-.037Zm.04-.039.245.181-.006.033.009.047-.051.012-.237-.234.04-.039Zm.037-.037.22.183.022.048-.034-.013-.245-.18.037-.038Zm.035-.034-.035.034.207.173.097-.002-.049-.063-.22-.142Zm.035-.035.256.114.014.066-.085-.003-.22-.142.035-.035Zm.03-.03.233.068.04.07-.047.006-.256-.114.03-.03Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.687 9.534.24.276m-.24-.276-.06.058.205.25.092.029.003-.061m-.24-.276.044-.044m.196.32.045.003-.011-.056m-.23-.267.23.267m-.23-.267.046-.046m.184.313.04-.002-.003-.058m-.22-.253.22.253m-.22-.253.037-.037m.183.29h.058l-.004-.056m-.237-.234.237.234m-.237-.234.04-.039m.197.273.05-.012-.008-.047.006-.033m-.245-.18.245.18m-.245-.18.037-.038m.208.218.034.013-.022-.048-.22-.183m0 0 .035-.034m-.035.034.207.173.097-.002-.049-.063m-.22-.142.22.142m-.22-.142.035-.035m.185.177.085.003-.014-.066m-.256-.114.256.114m-.256-.114.03-.03.233.068.04.07-.047.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.172 10.083-.012.109.11-.039.016.133-.116-.011.04.117-.133.017.01-.124-.11.039-.016-.133.116.011-.038-.103.133-.016ZM18.092 10.774l.015.09.079-.057.043.103-.095.017.059.085-.102.043-.02-.1-.08.056-.043-.102.095-.018-.053-.073.102-.043ZM19.296 8.866l.067.086.052-.104.104.084-.091.073.11.057-.084.104-.079-.096-.052.104-.104-.084.092-.073-.1-.047.085-.104Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.981 9.053c-.061-.005-.108.027-.143.098-.046.094-.087.243-.062.48.023.22.066.587.08.735.015.147.093.89.086.97-.018.199-.05.374-.22.388-.014.002-.027.001-.04.002.012.001.026.004.038.004.185-.007.296-.115.298-.424.002-.304-.054-.754-.068-.9-.012-.118-.11-.866-.095-1.013.015-.148.06-.321.192-.248.125.07.456.393.484.416l.052-.051c-.186-.165-.473-.414-.536-.44a.225.225 0 0 0-.066-.017h0Zm-.3 2.672a.563.563 0 0 1-.221-.094l-.04.033a.506.506 0 0 0 .261.061Zm-1.001-1.342c.09.345.267.83.445 1.03l.037.036.045-.038c-.017-.019-.038-.04-.05-.056-.18-.24-.34-.701-.41-.976a1.27 1.27 0 0 1-.067.004h0ZM19.347 8.709c.219.002.44.282.592.45l-.055.054c-.162-.208-.416-.48-.635-.492a.373.373 0 0 1 .098-.012Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.3 9.35c.05.402.114.847.126 1.058.032.537.088.767-.102 1.107-.103.183-.243.24-.605.215a.394.394 0 0 0 .071-.01c.37-.027.423-.153.495-.276.098-.191.127-.484.071-1.02-.013-.128-.096-.806-.14-1.148l.085.074Zm-.614 2.376.029.003c-.015 0-.028 0-.043-.002h.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC20",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.136 10.316a.99.99 0 0 1-.07.02c.078.251.18.633.367.876l.017.02.053-.043c-.128-.155-.249-.489-.367-.873Zm.67 1.104a.115.115 0 0 1-.08.003h.002l-.012.01c.068.024.14.032.212.02l.004-.027a.34.34 0 0 1-.125-.006v0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.582 8.517c-.306 0-.615.016-.736.107.003.016-.01.05-.03.057.18-.068.454-.098.766-.098.313 0 .586.03.767.098-.021-.007-.033-.041-.03-.057-.122-.091-.43-.107-.737-.107Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.582 8.583c-.312 0-.585.03-.767.098-.065.021-.074.099-.065.144.21-.103.499-.108.77-.108.008-.053.042-.073.062-.106.02.033.055.053.062.106.272 0 .562.005.77.108.01-.045 0-.123-.065-.144-.181-.068-.454-.098-.767-.098Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.521 8.717c-.271 0-.56.005-.77.108.004.022-.003.042-.027.05-.012.005-.019.05-.019.114.036-.14.416-.162.764-.165.011-.023.026-.038.06-.018a.239.239 0 0 1-.008-.09Zm.124 0a.238.238 0 0 1-.008.089c.035-.02.049-.005.06.018.348.003.729.025.764.165 0-.064-.006-.109-.018-.113-.024-.009-.032-.029-.027-.051-.21-.103-.5-.108-.771-.108ZM17.582 7.964c-.03.048-.086.066-.054.195-.082-.047-.05.098-.14.099.032.087.048.13.1.13.066 0 .037.01-.01.054-.041.04-.126.04-.194-.025a.113.113 0 0 1-.039-.072c.014-.111-.023-.133-.062-.12-.038.014-.064.055.001.134.022.045.007.081-.055.108-.103.045-.102.043-.076.006.041-.059.051-.137.016-.162a.197.197 0 0 1-.053-.08c-.007-.02-.024-.037-.035-.055-.02-.03-.05-.03-.108 0-.063.034-.068-.03-.1-.082a.961.961 0 0 0 .049.247.064.064 0 1 1 .03.115s0 0 0 0c.006.068-.017.116-.007.168.122-.09.43-.107.737-.107.306 0 .615.016.736.107.01-.052-.013-.1-.007-.167h-.005a.065.065 0 0 1-.046-.11.065.065 0 0 1 .082-.007.955.955 0 0 0 .049-.246c-.032.052-.038.116-.1.083-.059-.031-.089-.03-.108 0-.012.017-.028.033-.036.054a.197.197 0 0 1-.052.08c-.036.025-.026.103.016.162.026.037.026.039-.077-.006-.062-.027-.076-.063-.054-.108.064-.079.039-.12 0-.133-.038-.014-.076.008-.062.119a.113.113 0 0 1-.038.072c-.068.064-.153.065-.194.025-.047-.044-.077-.054-.01-.054.052 0 .068-.043.1-.13-.09 0-.058-.146-.14-.099.031-.129-.025-.147-.054-.195Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.614,
    d: "m17.521 7.33.012.134-.134-.013v.131l.134-.013-.012.154h.122l-.012-.154.134.013v-.131l-.134.013.012-.135h-.122Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.582 7.846c-.226 0-.428.15-.565.384.009.027.032.066.052.08.036.026.026.104-.016.163-.026.037-.026.039.077-.006.062-.027.076-.063.055-.108-.065-.079-.04-.12-.001-.133.038-.014.075.008.062.119a.113.113 0 0 0 .038.072c.068.064.153.065.194.025.047-.044.077-.054.01-.054-.052 0-.068-.043-.1-.13.09-.001.058-.146.14-.099-.031-.129.025-.147.054-.195.03.048.086.066.054.195.082-.047.05.098.14.098-.032.088-.048.13-.1.13-.066 0-.037.01.01.055.041.04.126.04.194-.025a.112.112 0 0 0 .039-.072c-.014-.111.023-.133.062-.12.038.014.064.055-.001.134-.022.045-.007.081.055.108.103.045.102.043.076.006-.042-.059-.051-.137-.016-.162a.197.197 0 0 0 .053-.08c-.138-.236-.34-.385-.566-.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.583 9.151c-.306 0-.747.034-.869.125a.496.496 0 0 0-.059.092c.171-.097.615-.133.928-.133.312 0 .756.036.927.133a.506.506 0 0 0-.06-.092c-.12-.091-.561-.125-.867-.125h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.583 8.61c-.03.049-.086.067-.054.196-.083-.047-.05.098-.14.098.032.088.048.13.099.13.067 0 .063.01.016.055-.041.04-.194.04-.262-.025A.114.114 0 0 1 17.204 9c.022-.11-.02-.136-.06-.125-.04.01-.068.046-.012.139.005.041-.042.075-.1.1-.104.046-.113.048-.086-.005.018-.04.016-.08.005-.093a.719.719 0 0 0-.057-.059c-.014-.013-.035-.003-.044.003l-.094.055c-.005.003-.024.016-.033.005-.017-.02-.056-.114-.073-.125-.014.016-.02.058-.025.078-.024-.005-.08-.03-.095-.034a.294.294 0 0 0 .015.098c.007.017.037.048.042.074a.091.091 0 0 1-.01.065c-.007.008-.011.024.008.024l.127.004c.016 0 .029.04.002.073.122-.091.563-.124.869-.124.306 0 .746.033.868.124-.027-.034-.014-.073.003-.073l.126-.004c.02 0 .015-.016.009-.024a.091.091 0 0 1-.01-.065c.004-.026.034-.057.04-.074a.292.292 0 0 0 .017-.098c-.015.004-.072.03-.095.034-.006-.02-.011-.062-.025-.078-.017.01-.056.106-.074.125-.01.01-.028-.002-.033-.005l-.094-.055c-.01-.006-.03-.016-.044-.003a.717.717 0 0 0-.057.059c-.011.014-.013.052.006.093.026.053.017.05-.086.006-.06-.026-.105-.06-.1-.101.056-.093.027-.128-.014-.139-.04-.01-.081.015-.06.125a.114.114 0 0 1-.037.065c-.068.064-.22.065-.262.025-.047-.044-.05-.055.016-.055.051 0 .067-.042.099-.13-.09 0-.057-.145-.14-.098.032-.129-.024-.147-.053-.195Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.582 9.235c-.312 0-.756.036-.927.133a.205.205 0 0 0-.025.1c.144-.121.47-.165.91-.168.013-.02.03-.036.043-.056.012.02.029.036.042.056.44.003.766.047.91.168a.206.206 0 0 0-.025-.1c-.171-.097-.615-.133-.928-.133Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.54 9.3c-.44.003-.766.047-.91.168.002.013.013.08.044.07.139-.049.51-.137.846-.142a.135.135 0 0 1 .02-.096Zm.085 0c.014.022.024.05.019.096.337.005.707.093.846.142.031.01.042-.057.044-.07-.144-.121-.47-.165-.91-.168ZM17.583 9.855c-.334 0-.605.02-.8.1-.022.092-.039.08-.034.131.225-.111.545-.132.834-.132.289 0 .608.021.833.132.005-.052-.012-.04-.035-.13-.194-.082-.465-.101-.798-.101Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.583 9.954c-.29 0-.609.021-.834.132.049.114.13.04.206.034a.177.177 0 0 0-.065.049c-.066.025-.05.085.005.077.038.04.126.075.25.1.125.025.28.039.438.04.158-.001.312-.015.437-.04s.213-.06.25-.1c.055.008.07-.05.007-.077a.167.167 0 0 0-.063-.05c.075.008.155.08.203-.033-.226-.11-.545-.132-.834-.132Zm0 .124c.086 0 .17.004.25.01.08.006.152.015.213.027.06.011.109.025.142.04.032.015.05.031.05.048 0 .033-.07.064-.192.088-.123.023-.29.036-.463.036-.174 0-.34-.013-.463-.036-.123-.024-.192-.055-.192-.088 0-.017.017-.033.05-.048a.65.65 0 0 1 .142-.04c.06-.012.133-.021.212-.027a3.2 3.2 0 0 1 .25-.01ZM17.582 9.244c-.029.048-.085.066-.053.195-.083-.047-.064.096-.154.097.032.088.083.135.135.135.067 0 .023.016-.031.051-.06.04-.17.029-.237-.035-.025-.024-.044-.042-.047-.067.018-.109-.015-.115-.056-.107-.041.009-.07.042-.005.121.014.04-.023.08-.044.092-.112.066-.126.056-.114.004.018-.071-.025-.109-.047-.125-.026-.02-.074-.039-.118.007-.073.075-.127-.03-.176-.02-.003.024.037.082.078.141a.064.064 0 0 1 .09.059.065.065 0 0 1-.022.048.12.12 0 0 1 .014.039c.152-.091.482-.125.787-.125.306 0 .636.034.788.125a.123.123 0 0 1 .014-.039.065.065 0 0 1-.02-.047.064.064 0 0 1 .088-.06c.04-.059.08-.117.078-.14-.049-.012-.103.094-.176.019-.044-.046-.091-.026-.118-.007-.022.016-.065.054-.047.125.012.052-.002.062-.113-.004-.022-.012-.059-.052-.045-.092.065-.079.037-.112-.005-.12-.041-.009-.074-.003-.056.106-.003.025-.021.043-.047.067-.068.064-.177.074-.237.035-.054-.035-.098-.05-.03-.05.05 0 .102-.048.134-.136-.09 0-.071-.144-.154-.097.032-.129-.024-.147-.053-.195Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M17.583 9.754c-.306 0-.635.034-.788.125a.156.156 0 0 1-.01.077c.194-.082.464-.1.798-.1.333 0 .604.018.799.1a.156.156 0 0 1-.011-.077c-.153-.091-.482-.125-.788-.125Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M18.445 9.523c-.01.033.033.067.047.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.614,
    d: "M17.525 7.723c-.039.03-.048.089-.048.134a.467.467 0 0 1 .211 0c0-.044-.01-.104-.048-.134h-.115Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.733,
    d: "M16.72 9.523c.01.033-.034.067-.047.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.01,
    strokeWidth: 0.75,
    d: "M16.86 8.457a.064.064 0 1 0 0-.128.064.064 0 0 0 0 .128ZM16.737 9.182a.064.064 0 1 0 0-.128.064.064 0 0 0 0 .128ZM17.583 8.345a.064.064 0 1 0 0-.129.064.064 0 0 0 0 .129ZM17.583 8.992a.064.064 0 1 0 0-.129.064.064 0 0 0 0 .129ZM17.583 9.63a.064.064 0 1 0 0-.129.064.064 0 0 0 0 .129ZM16.74 9.856a.064.064 0 1 0 0-.129.064.064 0 0 0 0 .13ZM18.307 8.458a.064.064 0 1 1 0-.129.064.064 0 0 1 0 .129ZM18.429 9.183a.064.064 0 1 1 0-.129.064.064 0 0 1 0 .129ZM18.428 9.857a.064.064 0 1 1 0-.128.064.064 0 0 1 0 .128Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.832 15.428c-.006 0-.012.005-.02.012l-.104.094-.011.015a.096.096 0 0 1 .065-.03.099.099 0 0 1 .09.049c.004-.02 0-.052-.003-.104-.001-.027-.007-.037-.017-.036Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.77 15.717a.099.099 0 1 0-.01-.197.099.099 0 0 0 .01.197Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.838 15.686c.068.034.096.127.1.238.002.012.001.025 0 .037a.214.214 0 0 0-.159-.056.217.217 0 0 0-.154.069.42.42 0 0 1-.004-.036c-.005-.111.015-.206.08-.245a.1.1 0 0 0 .07.024.1.1 0 0 0 .067-.03h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.78 15.905c.333-.015.305.573.314.761h-.002l.002-.004c0-.01-.008-.019-.023-.027a.224.224 0 0 0-.062-.02 1.008 1.008 0 0 0-.385.015c-.05.013-.082.031-.088.05h-.002c-.009-.189-.088-.76.245-.775Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.817 16.748c-.155.007-.282-.02-.284-.06-.001-.04.122-.08.277-.086.155-.007.281.02.283.06.002.04-.122.079-.276.086Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.958 16.606c-.01-.215-.014-.304-.041-.39M18.04 16.617c-.003-.088-.005-.24-.02-.316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.574 13.618c-.002-.048-.002-.055.028-.083l.11-.1c.021-.018.035-.019.038.025.001.042.002.055-.02.075l-.111.101c-.026.024-.043.03-.045-.018Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.579 13.727c-.002-.048-.002-.055.028-.083l.11-.1c.021-.018.035-.019.037.025.002.042.003.055-.019.075l-.111.101c-.027.024-.043.03-.045-.018ZM17.569 13.506c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.019.038.025.002.042.002.054-.02.075a27.51 27.51 0 0 1-.111.101c-.026.024-.043.03-.045-.019ZM17.56 13.283c-.003-.048-.003-.056.027-.083l.11-.1c.021-.018.036-.019.038.025.002.042.003.055-.019.075a27.61 27.61 0 0 1-.112.101c-.026.024-.043.03-.045-.018Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.564 13.395c-.002-.048-.002-.056.028-.083l.11-.1c.021-.018.036-.019.038.025.002.042.002.054-.02.075l-.11.101c-.027.024-.044.03-.046-.018ZM17.553 13.171c-.002-.047-.002-.055.029-.082l.11-.1c.02-.019.035-.019.037.024.002.043.003.055-.019.075-.013.012-.097.09-.112.102-.026.024-.043.03-.045-.019ZM17.604 14.288c-.002-.048-.002-.055.028-.083l.11-.1c.021-.018.036-.018.038.025.002.042.002.055-.02.075l-.11.101c-.027.024-.044.03-.046-.018Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.609 14.4c-.002-.048-.002-.055.028-.083l.11-.1c.021-.018.036-.019.038.025.002.042.002.055-.02.075a27.61 27.61 0 0 1-.111.101c-.026.024-.043.03-.045-.018ZM17.6 14.177c-.003-.048-.003-.055.027-.083l.11-.1c.022-.018.036-.019.038.025.002.042.003.055-.019.075l-.112.101c-.026.024-.043.03-.045-.018ZM17.59 13.953c-.003-.048-.002-.055.028-.083l.11-.1c.02-.018.035-.018.037.025.002.042.003.055-.019.075a21.7 21.7 0 0 1-.111.101c-.027.024-.043.03-.046-.018Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.593 14.065c-.002-.048-.002-.055.029-.083l.11-.1c.02-.018.035-.019.037.025.002.042.003.055-.019.075l-.112.101c-.026.024-.042.03-.045-.018ZM17.584 13.841c-.003-.047-.002-.054.028-.082l.11-.1c.02-.019.035-.019.037.025.002.042.003.055-.019.075l-.111.101c-.027.024-.043.03-.045-.018ZM17.634 14.958c-.002-.048-.001-.055.029-.082l.11-.1c.02-.02.035-.02.037.024.002.042.003.055-.019.075l-.112.102c-.026.023-.042.029-.045-.019ZM17.64 15.07c-.002-.048-.002-.056.029-.083l.11-.1c.02-.019.035-.02.037.024.002.042.003.055-.019.075l-.112.102c-.026.024-.043.03-.045-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.63 14.846c-.002-.047-.001-.055.029-.082l.11-.1c.02-.019.035-.02.037.024.002.042.003.055-.019.075l-.111.102c-.027.023-.043.029-.045-.019ZM17.619 14.623c-.002-.048-.002-.055.028-.082.012-.011.094-.087.11-.1.021-.02.035-.02.037.024.002.042.003.055-.018.075a27.51 27.51 0 0 1-.112.102c-.027.023-.043.029-.045-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.625 14.734c-.003-.047-.002-.055.028-.082l.11-.1c.021-.019.035-.02.037.024.002.042.003.055-.019.075l-.111.102c-.027.023-.043.029-.045-.019ZM17.614 14.511c-.002-.048-.002-.055.028-.082l.11-.1c.021-.02.036-.02.038.024.002.042.002.055-.02.075l-.111.102c-.026.023-.043.029-.045-.019ZM17.666 15.512c-.003-.048-.002-.056.028-.083l.11-.1c.021-.019.035-.019.037.025.002.042.003.055-.019.075l-.111.101c-.027.024-.043.03-.045-.018ZM17.65 15.293c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.02.038.024.002.042.002.055-.02.075l-.111.102c-.026.023-.043.029-.045-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.654 15.404c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.019.038.024.002.043.002.055-.02.075l-.111.102c-.027.024-.043.03-.045-.019ZM17.645 15.181c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.02.038.024.002.042.002.055-.02.075l-.11.102c-.027.023-.044.029-.046-.019ZM17.534 12.724c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.035-.019.037.024.002.043.003.055-.018.075l-.112.102c-.027.024-.043.03-.045-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.538 12.833c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.035-.019.037.024.002.043.003.055-.018.075l-.112.102c-.027.024-.043.03-.045-.019ZM17.528 12.613c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.02.038.024.002.042.002.055-.02.075l-.111.102c-.026.023-.043.029-.045-.019ZM17.518 12.39c-.002-.048-.002-.056.028-.083l.11-.1c.021-.019.036-.019.038.024.002.043.003.055-.02.075l-.11.102c-.027.024-.044.03-.046-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.524 12.501c-.002-.047-.002-.055.028-.082l.11-.1c.021-.019.036-.02.038.024.002.042.002.055-.02.075l-.111.102c-.026.024-.043.03-.045-.019ZM17.512 12.278c-.002-.048-.002-.055.029-.082l.11-.1c.02-.019.035-.02.037.024.002.042.003.055-.019.075l-.112.102c-.026.023-.042.029-.045-.019ZM17.55 13.06c-.003-.048-.002-.056.028-.083l.11-.1c.02-.019.035-.019.037.025.002.042.003.054-.019.074-.013.012-.097.09-.112.102-.026.024-.042.03-.045-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.544 12.948c-.003-.047-.002-.055.028-.082l.11-.1c.02-.019.035-.019.037.024.002.043.003.055-.019.075a27.51 27.51 0 0 1-.111.102c-.027.024-.043.03-.045-.019ZM17.509 12.166c-.003-.047-.002-.055.028-.082l.11-.1c.02-.019.035-.02.037.024.002.042.003.055-.019.075l-.112.102c-.026.023-.042.029-.044-.019ZM17.503 12.055c-.003-.048-.002-.055.028-.082.012-.011.094-.087.11-.1.02-.02.035-.02.037.024.002.042.003.055-.019.075a27.51 27.51 0 0 1-.111.101c-.027.024-.043.03-.045-.018ZM17.502 13.678c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 13.787c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.021ZM17.502 13.566c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.027-.044-.02ZM17.502 13.342c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.022-.044.027-.044-.02ZM17.502 13.454c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.027-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 13.231c0-.047 0-.055.032-.08.012-.011.098-.083.114-.095.022-.018.037-.018.037.025s0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.02ZM17.502 14.349c0-.048 0-.055.032-.081a20.2 20.2 0 0 1 .114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02ZM17.502 14.46c0-.047 0-.054.032-.08l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 14.237c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.022-.044.027-.044-.02ZM17.502 14.013c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .054-.023.073l-.116.097c-.027.022-.044.027-.044-.02ZM17.502 14.125c0-.047 0-.055.032-.08a20.2 20.2 0 0 1 .114-.095c.022-.018.037-.018.037.026 0 .042 0 .054-.023.073l-.116.097c-.027.022-.044.027-.044-.02ZM17.502 13.902c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02ZM17.502 15.02c0-.048 0-.056.032-.081a20.2 20.2 0 0 1 .114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 15.13c0-.047 0-.054.032-.08l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.021ZM17.502 14.908c0-.048 0-.056.032-.082l.114-.094c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.027-.044-.02ZM17.502 14.684c0-.047 0-.055.032-.08.012-.011.098-.083.114-.095.022-.018.037-.018.037.025 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 14.796c0-.048 0-.056.032-.082l.114-.094c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.022-.044.027-.044-.02ZM17.502 14.572c0-.047 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.02ZM17.502 15.652c0-.045 0-.052.032-.076l.114-.089c.022-.017.037-.017.037.024 0 .04 0 .052-.023.07l-.116.09c-.027.022-.044.026-.044-.019ZM17.502 15.758c0-.045 0-.052.032-.077l.114-.089c.022-.017.037-.016.037.025 0 .04 0 .051-.023.07l-.116.09c-.027.021-.044.026-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 15.547c0-.044 0-.051.032-.076l.114-.089c.022-.017.037-.016.037.025 0 .04 0 .051-.023.07l-.116.09c-.027.021-.044.026-.044-.02ZM17.502 15.337c0-.044 0-.051.032-.076l.114-.089c.022-.017.037-.016.037.024s0 .052-.023.07c-.013.01-.101.08-.116.09-.027.022-.044.026-.044-.019Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 15.442c0-.045 0-.052.032-.076l.114-.09c.022-.016.037-.016.037.025 0 .04 0 .052-.023.07l-.116.09c-.027.021-.044.026-.044-.019ZM17.502 15.232c0-.045 0-.052.032-.076l.114-.09c.022-.016.037-.016.037.025 0 .04 0 .052-.023.07l-.116.09c-.027.021-.044.026-.044-.02ZM17.502 12.784c0-.048 0-.056.032-.081l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.027-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 12.893c0-.048 0-.056.032-.081l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.027-.044-.02ZM17.502 12.672c0-.047 0-.055.032-.08a20.2 20.2 0 0 1 .114-.095c.022-.018.037-.018.037.026 0 .042 0 .054-.023.074l-.116.096c-.027.022-.044.027-.044-.02ZM17.501 12.448c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.025s0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.02ZM17.502 12.56c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .054-.023.073l-.116.097c-.027.022-.044.027-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 12.337c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.021ZM17.502 13.119c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.097c-.027.022-.044.027-.044-.021Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 13.008c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02ZM17.502 12.225c0-.048 0-.055.032-.081l.114-.095c.022-.018.037-.017.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.023-.044.028-.044-.02Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 12.113c0-.047 0-.055.032-.08l.114-.095c.022-.018.037-.018.037.026 0 .042 0 .055-.023.074l-.116.096c-.027.022-.044.027-.044-.02ZM17.512 11.892c-.007.045.006.04.031.02.022-.018.095-.037.11-.049.015-.013.014-.012.026-.018-.002-.037-.049-.05-.089-.043-.052.014-.067.041-.078.09Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 12.001c0-.047.013-.045.032-.08a.213.213 0 0 1 .082-.08c.027-.01.06-.032.063.011.003.042.006.054-.017.073l-.116.097c-.027.022-.044.027-.044-.02ZM17.989 12.011a.012.012 0 0 0-.012.009c.005.016.012.03.02.043.019.034.037.07.057.103.005.009.012.018.02.025l.064.023h.002a.064.064 0 0 0-.007-.035c-.02-.036-.036-.075-.056-.11a.097.097 0 0 0-.084-.057.01.01 0 0 0-.004 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.08 12.039c-.005 0-.01.007-.009.014.004.02.018.038.026.057.017.033.03.067.05.097l.01.014.055.02c.01-.009 0-.027-.002-.039a.491.491 0 0 0-.041-.109.093.093 0 0 0-.085-.053l-.003-.001ZM17.901 11.98c.032.003.065.017.081.05.02.031.037.066.057.099.01.014.017.03.015.048a.091.091 0 0 1-.084-.043c-.024-.033-.044-.069-.067-.102a.12.12 0 0 1-.021-.048c.005-.007.013-.004.02-.005ZM17.7 11.915c.026.001.053.01.073.03.022.028.04.06.06.09.013.021.037.038.038.066-.031.012-.067-.002-.092-.022-.022-.02-.038-.048-.055-.073-.015-.026-.038-.049-.043-.08 0-.009.01-.015.018-.011Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.793 11.95c.03 0 .064.01.084.037.024.03.041.064.063.095.01.017.027.036.025.058-.028.008-.057-.006-.08-.024-.024-.022-.04-.051-.059-.078l-.045-.07c-.003-.008.003-.021.012-.018ZM17.599 11.886c.034 0 .069.019.086.052.022.035.043.072.068.105.007.01.012.02.014.032-.028.016-.062.003-.089-.011-.028-.02-.042-.056-.06-.086-.013-.026-.03-.052-.036-.08 0-.009.01-.016.017-.012Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    d: "m17.583 11.892-.002.002.002.003.001-.004h-.001Zm0 .005c-.006.03-.023.055-.036.081-.015.024-.027.052-.045.072l-.003.008c.058.035.12.03.165-.007a.38.38 0 0 1-.045-.073c-.014-.026-.03-.052-.036-.08Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m17.583 11.897-.002-.004h.003a.01.01 0 0 0-.001.004Zm0 0c-.006.03-.023.055-.036.081-.015.024-.027.052-.045.072l-.003.008c.058.035.12.03.165-.007a.38.38 0 0 1-.045-.073c-.014-.026-.03-.052-.036-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.936 13.383a.088.088 0 0 0-.035.098c.008.033.017.066.021.1.002.023.037.032.044.007a.095.095 0 0 0 .013-.087c-.009-.035-.016-.07-.026-.104-.003-.007-.008-.016-.017-.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.882 13.46a.093.093 0 0 0-.036.093l.026.116c.013.027.047.002.05-.02.015-.03.005-.065-.002-.096-.009-.03-.01-.063-.027-.09a.013.013 0 0 0-.011-.004ZM16.98 13.31a.09.09 0 0 0-.025.09c.007.032.017.065.022.098 0 .018.023.037.037.018.024-.024.028-.061.019-.092-.01-.035-.016-.07-.026-.104-.003-.012-.017-.025-.027-.01ZM17.08 13.15a.088.088 0 0 0-.025.1c.01.034.021.066.028.1.003.022.038.03.044.005a.095.095 0 0 0 .006-.088c-.01-.034-.02-.068-.033-.102-.003-.007-.01-.017-.02-.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.027 13.24a.09.09 0 0 0-.02.091c.01.033.022.065.028.098.002.018.026.036.039.016.022-.025.024-.063.013-.093l-.031-.103c-.005-.011-.019-.023-.029-.009ZM17.127 13.069a.086.086 0 0 0-.026.091l.026.083c.004.017.007.055.035.045.025-.017.03-.052.025-.08-.005-.029-.019-.056-.026-.085-.007-.019-.009-.051-.034-.054ZM16.582 13.807c-.029.02-.048.056-.041.09l.021.117c.013.028.048.006.052-.016.02-.032.007-.07.001-.103-.007-.027-.004-.059-.02-.083-.002-.004-.008-.006-.013-.005Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.53 13.885a.707.707 0 0 1-.014.174c.019.007.039.005.043-.01.008-.036.001-.046-.004-.078-.01-.027-.003-.066-.026-.086ZM16.643 13.731c-.027.02-.046.055-.04.09.007.038.014.076.019.114.01.03.05.01.054-.013.02-.032.007-.07 0-.105-.006-.028-.003-.063-.023-.085l-.005-.002-.005.001ZM16.765 13.579c-.027.02-.045.055-.039.09.007.037.014.075.018.113.01.03.05.01.054-.013.016-.027.01-.06.004-.088-.007-.031-.008-.065-.02-.095-.003-.006-.01-.01-.017-.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.705 13.655c-.027.02-.046.055-.04.09.007.037.015.075.02.114.009.029.049.01.053-.014.019-.032.007-.07 0-.104-.006-.028-.003-.063-.023-.086l-.005-.001-.005.001ZM16.823 13.526c-.027.021-.044.058-.035.092l.025.118c.015.025.047-.002.05-.022.015-.03.007-.063-.002-.093-.01-.03-.006-.07-.029-.094l-.004-.002h-.005ZM17.306 12.737a.089.089 0 0 0-.024.095l.04.117c.014.024.043 0 .045-.02.013-.03.003-.063-.01-.092-.012-.03-.017-.064-.034-.093-.004-.005-.01-.009-.017-.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.262 12.817a.09.09 0 0 0-.023.096l.038.116c.015.024.044 0 .046-.02.013-.03.003-.063-.009-.092-.013-.03-.018-.064-.035-.093-.003-.005-.01-.009-.017-.007ZM17.352 12.654a.088.088 0 0 0-.024.096l.04.117c.014.023.044 0 .046-.02.013-.03.003-.064-.01-.092-.013-.031-.018-.065-.035-.094-.004-.005-.01-.009-.017-.007ZM17.45 12.489h-.005c-.026.023-.039.062-.025.095l.04.117c.012.02.034.008.043-.007a.1.1 0 0 1-.002-.022c0-.028 0-.042.007-.054a.317.317 0 0 0-.011-.032c-.013-.03-.018-.062-.035-.09a.02.02 0 0 0-.012-.008Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.398 12.57a.088.088 0 0 0-.024.097l.04.117c.014.024.045 0 .047-.02.013-.032.001-.068-.012-.098-.012-.029-.017-.06-.034-.088-.003-.005-.01-.009-.017-.007ZM17.172 12.986a.085.085 0 0 0-.027.088l.027.084c.005.018.008.057.036.047.025-.016.03-.052.025-.08-.006-.029-.02-.056-.027-.085-.008-.018-.01-.051-.034-.054Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.216 12.902a.091.091 0 0 0-.024.096l.038.117c.014.024.043 0 .045-.02.013-.03.003-.064-.008-.092-.013-.03-.018-.064-.035-.093-.003-.005-.01-.01-.016-.008ZM17.501 12.426h-.003c-.026.023-.038.063-.024.095.01.033.022.065.033.097a.08.08 0 0 1 .02-.023v-.002c-.016.01-.026.004-.026-.033 0-.042 0-.053.021-.072v-.005c-.013.005-.021-.002-.021-.035v-.022h0ZM16.09 14.882c-.032.005-.054.034-.07.06l-.052.082c.014.025.046.034.073.029.03-.006.05-.03.064-.055.014-.028.038-.05.053-.077.01-.028-.029-.037-.05-.037l-.017-.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.189 14.908c-.038.013-.055.052-.076.082l-.039.062c.024.022.06.032.091.02.028-.012.042-.042.058-.066.012-.027.04-.047.046-.077-.015-.023-.049-.023-.074-.022l-.006.001h0ZM15.98 14.859c-.032.005-.054.034-.07.06l-.053.082c.015.025.047.034.074.028.03-.005.05-.03.064-.054.013-.029.037-.05.052-.077.01-.029-.028-.037-.049-.037l-.018-.002ZM15.792 14.813h-.012c-.002.01-.01.017-.018.022-.032.021-.057.05-.088.072a.144.144 0 0 0-.025.04c.029.026.075.038.107.013.03-.023.048-.059.078-.082.017-.011.03-.043.006-.053a.236.236 0 0 0-.048-.012Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.875 14.837a.058.058 0 0 0-.022.005c.002.013-.008.029-.019.036-.028.021-.044.053-.07.076l-.019.03c.027.024.071.033.102.011.031-.021.042-.06.066-.087.01-.015.032-.034.022-.052-.011-.015-.032-.017-.049-.018a.056.056 0 0 0-.011 0ZM15.727 14.775c-.001.01-.013.016-.022.02-.036.015-.067.04-.103.055a.07.07 0 0 1-.014.005h0l-.016.015c-.003.006-.018.013-.008.02.05.061.074.041.107.02.033-.023.058-.053.09-.075.01-.007.025-.019.015-.032-.008-.013-.024-.019-.037-.024a.06.06 0 0 0-.012-.004ZM16.789 14.984c-.039-.007-.076.018-.095.05-.021.031-.04.064-.06.096-.01.015.005.029.02.031a.088.088 0 0 0 .099-.04c.02-.03.037-.062.057-.092.009-.01.022-.036.002-.042l-.023-.003Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.915 14.99a.104.104 0 0 0-.095.03c-.027.038-.05.079-.076.117-.01.013 0 .032.017.031a.09.09 0 0 0 .098-.035c.021-.03.036-.063.058-.091.013-.013.028-.042.005-.052h-.007 0ZM16.668 14.976c-.039-.007-.074.022-.091.054l-.062.099c.024.03.074.03.104.007.026-.02.038-.053.057-.08.013-.02.027-.04.037-.061-.005-.02-.029-.017-.045-.02ZM16.44 14.947c-.034-.006-.063.019-.08.045l-.055.087c-.004.01-.011.022.003.028a.08.08 0 0 0 .103-.012c.024-.027.036-.063.06-.09.014-.014.028-.045.001-.053-.01-.004-.021-.005-.032-.005Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.554 14.963c-.04-.006-.073.024-.09.057l-.059.094c.02.023.052.029.08.02.034-.01.052-.043.068-.072.014-.028.042-.048.046-.079.001-.02-.032-.017-.045-.02ZM16.307 14.928c-.04.008-.058.048-.08.079-.013.022-.03.044-.04.068a.077.077 0 0 0 .095.015c.032-.019.045-.057.066-.086.014-.017.043-.044.022-.065-.018-.011-.043-.011-.063-.01ZM17.478 14.993a.099.099 0 0 0-.106.05c-.022.035-.042.07-.065.103-.01.014.002.03.018.03a.095.095 0 0 0 .09-.03c.022-.028.038-.06.058-.09.012-.016.037-.04.018-.06-.004-.002-.008-.002-.013-.003Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.502 15.022c-.024.025-.039.057-.057.086-.008.02-.037.04-.023.063a.095.095 0 0 0 .087-.006c-.005-.005-.007-.016-.007-.034 0-.048 0-.055.032-.08-.008 0-.031.024-.032-.029v0ZM17.36 14.992a.101.101 0 0 0-.1.048c-.022.032-.038.068-.062.1-.012.014-.004.04.018.037.039.006.08-.014.1-.048.02-.032.035-.066.06-.094.011-.013.016-.046-.01-.043h-.006ZM17.132 14.992a.105.105 0 0 0-.101.057c-.02.03-.037.063-.06.093-.007.01-.01.032.01.032a.093.093 0 0 0 .084-.016c.027-.024.041-.058.06-.088.011-.023.04-.04.034-.068-.003-.012-.017-.01-.027-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.251 14.993a.094.094 0 0 0-.083.023c-.026.026-.041.06-.061.091-.008.02-.027.035-.028.056.005.018.03.013.043.015.04 0 .071-.029.088-.062.017-.032.04-.062.059-.092.007-.014.002-.034-.018-.03ZM17.02 14.991c-.036-.002-.074.012-.093.043-.024.036-.044.074-.07.108-.013.019.011.037.029.033a.089.089 0 0 0 .088-.042c.022-.03.038-.065.061-.095.01-.011.022-.037.003-.045-.006-.002-.012-.001-.018-.002ZM15.688 14.732a.054.054 0 0 1-.02.009c-.037.009-.096.036-.134.045a.056.056 0 0 1-.014.002l-.008.005c-.004.005-.02.01-.012.018.034.065.037.063.102.04.037-.016.067-.04.103-.056.012-.005.028-.014.02-.029-.005-.014-.02-.022-.032-.03l-.005-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m15.658 14.68-.005.001c-.037.004-.095.021-.132.025-.008.001-.015 0-.02-.002-.01.005-.024.007-.022.033.008.04.017.059.056.05.038-.01.096-.037.134-.046.012-.003.03-.01.024-.025a.058.058 0 0 0-.021-.034c-.003-.002-.012 0-.014-.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.66 14.622c-.008.005-.017.006-.032.007-.039.003-.069.01-.107.006-.004-.002-.024 0-.035-.01-.006.004-.013.025-.01.034.004.036.007.051.045.047.037-.004.095-.021.132-.025.011-.001.028-.005.025-.02a.077.077 0 0 0-.019-.039Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.507 14.55c-.014.007-.022.022-.027.056-.001.033.035.027.042.03.038.003.067-.004.106-.007.028-.002.035-.002.047-.03a.068.068 0 0 0 .006-.032c-.009.007-.018.006-.038.005-.038-.003-.069-.001-.106-.01-.004-.003-.02-.003-.03-.013Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.528 14.478c-.011.007-.02.02-.028.048-.006.032.03.032.037.036.037.009.067.007.106.01.028.002.035.004.051-.022a.086.086 0 0 0 .012-.045c-.013.013-.021.01-.044.007-.039-.007-.069-.008-.105-.02-.004-.003-.02-.005-.029-.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.543 14.418a.129.129 0 0 0-.02.035c-.009.032.028.034.034.039.036.012.066.013.104.02.028.004.035.007.053-.017a.058.058 0 0 0 .011-.02c-.008.006-.018.007-.034 0-.033-.012-.096-.038-.13-.048a.056.056 0 0 1-.018-.009ZM15.671 14.239c-.02.002-.033.02-.047.038-.01.016.01.029.023.032.031.011.096.045.126.057.027.014.034-.003.05-.026a.06.06 0 0 0 .01-.026c-.008.005-.016.006-.03-.002-.029-.015-.09-.054-.12-.067a.052.052 0 0 1-.012-.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.568 14.35c-.013.007-.02.026-.032.044-.01.017.012.03.026.033.033.01.097.036.13.047.029.014.035.001.056-.024a.082.082 0 0 0 .011-.018c-.008.005-.018.005-.033-.003-.033-.014-.097-.043-.13-.055-.011-.003-.027-.012-.028-.024Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.618 14.293c-.022 0-.03.024-.048.047-.01.016.012.03.025.034.034.012.098.041.13.055.03.015.037.003.059-.022.009-.01.022-.028.012-.037-.006.002-.014.002-.024-.004-.03-.012-.095-.046-.126-.057a.043.043 0 0 1-.024-.016h-.004ZM15.714 14.177c-.02 0-.03.023-.047.041-.011.015.003.022.015.027.03.013.092.052.121.067.026.016.034 0 .052-.022a.07.07 0 0 0 .011-.02.037.037 0 0 1-.014-.007c-.028-.017-.079-.053-.107-.069a.052.052 0 0 1-.01-.008c-.006-.001-.016-.01-.02-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.777 14.13c-.018 0-.034.014-.05.03-.011.012.006.028.018.034.028.015.079.052.106.069.024.017.033.002.053-.017l.002-.004-.002-.001c-.028-.017-.078-.062-.107-.077-.012-.005-.03-.02-.02-.034Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.827 14.096c-.018.001-.033.016-.049.032-.012.014.007.03.02.036.028.015.078.06.107.077l.012.006c.01-.006.018-.01.035-.023.004-.002.006-.006.01-.009a.033.033 0 0 1-.018-.009c-.026-.02-.07-.07-.098-.089a.044.044 0 0 1-.019-.021Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.883 14.053c-.018 0-.035.013-.053.027-.013.012.003.03.015.037.027.019.071.07.098.09a.033.033 0 0 0 .017.008.296.296 0 0 0 .028-.027c-.024-.024-.061-.076-.086-.097-.01-.007-.023-.025-.013-.037h-.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.942 14.03c-.016 0-.033.01-.05.022-.015.011 0 .031.01.039.025.02.063.073.087.097a.278.278 0 0 0 .024-.034c-.02-.027-.043-.065-.06-.082-.01-.01-.024-.03-.008-.04h.001l-.004-.001Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M15.99 14.015a.115.115 0 0 0-.045.017c-.016.01-.003.03.007.04.018.017.041.055.061.082a.284.284 0 0 0 .026-.05.342.342 0 0 0-.03-.043c-.01-.01-.021-.031-.005-.04l.005-.002a.04.04 0 0 0-.018-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M16.047 14.007a.126.126 0 0 0-.043.014c-.016.009-.004.03.005.04.009.01.02.027.03.044a.286.286 0 0 0 .02-.097.043.043 0 0 0-.012-.001ZM17.176 12.011c.005 0 .01.003.012.009a.196.196 0 0 1-.02.043c-.019.034-.037.07-.057.102a.127.127 0 0 1-.02.026l-.064.023h-.002a.064.064 0 0 1 .007-.036c.02-.036.036-.074.056-.11a.097.097 0 0 1 .084-.056.011.011 0 0 1 .004 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.084 12.039c.006-.001.01.006.01.013-.004.021-.018.039-.026.058-.017.032-.03.066-.05.097a.146.146 0 0 1-.01.014l-.055.02c-.01-.01 0-.028.003-.04a.486.486 0 0 1 .04-.108.094.094 0 0 1 .085-.054h.003ZM17.264 11.979c-.032.003-.065.018-.081.05-.02.031-.037.066-.057.099-.009.014-.017.03-.015.048a.09.09 0 0 0 .084-.043c.024-.033.044-.069.067-.102a.12.12 0 0 0 .021-.048c-.005-.006-.013-.004-.02-.004ZM17.466 11.915a.108.108 0 0 0-.074.03c-.022.028-.04.06-.06.089-.013.022-.037.039-.038.067.031.012.067-.002.092-.023.022-.02.038-.047.055-.072.015-.026.038-.049.043-.08 0-.01-.01-.015-.018-.011Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.371 11.95c-.03 0-.064.01-.084.036-.023.03-.041.064-.063.095-.01.018-.027.037-.025.058.028.009.057-.006.08-.024.024-.022.04-.051.059-.078.015-.023.031-.046.045-.07.003-.008-.003-.02-.012-.018ZM17.566 11.886a.099.099 0 0 0-.085.052c-.023.035-.044.072-.07.105a.077.077 0 0 0-.013.032c.028.015.062.003.089-.011.028-.021.042-.056.06-.086.013-.026.03-.052.036-.081 0-.008-.01-.015-.017-.011ZM18.228 13.383c.032.02.045.063.035.098-.008.033-.017.066-.021.1-.002.023-.037.032-.044.007a.095.095 0 0 1-.013-.087c.009-.034.016-.07.026-.104.003-.007.008-.016.017-.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.281 13.46a.093.093 0 0 1 .036.093l-.026.116c-.013.027-.047.002-.05-.02-.015-.03-.005-.064.003-.095.008-.03.01-.063.026-.09.003-.004.007-.005.011-.004ZM18.183 13.31a.09.09 0 0 1 .026.09c-.008.032-.018.065-.022.098-.001.018-.024.037-.038.019-.024-.024-.028-.062-.019-.093.01-.034.016-.07.026-.104.003-.012.017-.024.027-.01ZM18.082 13.151c.03.023.04.066.026.1-.01.033-.021.065-.028.099-.003.023-.038.03-.044.005a.095.095 0 0 1-.006-.088c.011-.034.02-.068.033-.101.004-.008.01-.018.02-.015Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.136 13.24a.09.09 0 0 1 .02.091c-.01.033-.022.065-.028.098-.002.018-.026.036-.039.017-.022-.026-.024-.063-.013-.094.011-.034.02-.069.032-.102.004-.012.018-.024.028-.01ZM18.036 13.069c.026.021.037.06.026.091a1.495 1.495 0 0 1-.026.083c-.004.017-.007.055-.035.045-.025-.017-.03-.052-.025-.08.005-.029.019-.056.026-.085.008-.019.009-.051.034-.054ZM18.58 13.807c.029.02.049.056.041.09l-.021.117c-.013.028-.048.006-.052-.015-.019-.033-.007-.07 0-.104.006-.027.003-.058.018-.082.003-.005.009-.007.014-.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.634 13.885a.707.707 0 0 0 .013.175c-.019.006-.039.004-.043-.01-.008-.036-.001-.047.004-.079.01-.027.003-.066.026-.086ZM18.52 13.732c.027.02.046.054.04.089-.007.038-.014.076-.019.114-.01.03-.05.01-.054-.013-.02-.032-.007-.07 0-.105.006-.028.003-.063.023-.085l.005-.001h.005ZM18.398 13.579c.027.02.045.055.039.09-.007.037-.014.075-.018.113-.01.03-.05.01-.054-.013-.016-.027-.01-.06-.004-.088.008-.031.008-.065.02-.095.003-.006.01-.01.017-.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.458 13.655c.027.02.046.055.04.09-.007.038-.015.075-.019.114-.01.029-.05.01-.053-.013-.02-.033-.007-.07-.002-.105.007-.028.004-.063.024-.086h.01ZM18.34 13.526c.027.021.044.058.035.092l-.025.118c-.015.025-.047-.001-.05-.022-.015-.03-.007-.063.002-.093.01-.03.006-.07.029-.094l.004-.001h.005ZM17.858 12.737a.089.089 0 0 1 .023.096 6.957 6.957 0 0 0-.04.116c-.013.024-.043 0-.045-.02-.013-.03-.002-.063.01-.092.012-.03.017-.064.034-.093.004-.005.01-.009.018-.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.902 12.817a.09.09 0 0 1 .023.096 6.634 6.634 0 0 0-.038.117c-.015.024-.044 0-.046-.02-.013-.03-.003-.064.009-.092.013-.031.018-.065.035-.093.003-.006.01-.01.017-.008ZM17.811 12.654a.089.089 0 0 1 .024.096 6.19 6.19 0 0 0-.04.117c-.014.023-.044 0-.045-.02-.014-.03-.004-.064.009-.092.013-.031.018-.065.035-.094.004-.005.01-.008.017-.007ZM17.686 12.53s0 0 0 0l-.001.004c.014-.008.024-.002.025.033.002.041.003.054-.018.074.012-.005.02.002.022.027l.03-.084a.086.086 0 0 0-.018-.088s-.026.034-.04.034Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.76 12.571a.019.019 0 0 0-.012.008c-.017.027-.022.058-.034.087V12.675c.003.04.003.054-.016.073l.001.007c.012-.004.02.005.02.035.01.006.022.006.03-.006l.04-.117c.014-.033.002-.072-.024-.096h-.005ZM17.992 12.986c.024.02.036.057.026.088a1.362 1.362 0 0 1-.027.084c-.005.018-.008.057-.036.047-.025-.016-.03-.052-.025-.08.006-.029.02-.056.027-.085.008-.018.01-.051.035-.054Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.947 12.903a.09.09 0 0 1 .024.095l-.038.117c-.014.024-.043 0-.045-.02-.013-.03-.003-.064.008-.092.013-.03.018-.064.035-.093.003-.005.01-.009.016-.007ZM17.502 12.334s0 0 0 0l-.065.11c-.014.024-.014.033 0 .053a.108.108 0 0 1 .008-.008h.005a.02.02 0 0 1 .013.007.17.17 0 0 1 .012.025c-.014-.033-.001-.071.025-.095h.003c0-.021.003-.032.016-.045v-.007c-.011.001-.018-.009-.017-.037v-.003h0Zm-.027.188.004.013s0 0 0 0a.279.279 0 0 0-.004-.013Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.457 12.238c-.01 0-.016.007-.023.018l-.064.11c-.018.03-.014.035.015.069.029.034.043.024.06-.002l.057-.1c0-.024 0-.038.007-.049a.294.294 0 0 0-.02-.024c-.013-.015-.024-.022-.032-.022ZM17.317 12.355c-.029-.033-.033-.039-.015-.069l.065-.11c.013-.021.028-.026.055.005.025.03.033.038.02.06a11.78 11.78 0 0 1-.065.112c-.016.027-.03.036-.06.002ZM17.2 12.126l-.005.007a.096.096 0 0 1-.037.034.16.16 0 0 0 .023.03c.03.034.044.025.06-.002l.055-.094h-.003v-.002a.155.155 0 0 1-.014.016c-.023.018-.052.033-.08.024l.001-.013Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.35 12.099a.081.081 0 0 1-.055.002l-.062.106c-.018.03-.014.036.015.07.03.033.044.024.06-.003l.066-.112c.012-.022.004-.03-.021-.06l-.003-.003ZM19.073 14.882c.033.005.055.034.071.06l.052.082c-.014.025-.046.034-.073.029-.03-.006-.05-.03-.064-.055-.014-.028-.037-.05-.053-.077-.01-.028.03-.037.05-.037l.017-.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.974 14.908c.037.013.055.052.075.082l.04.062a.087.087 0 0 1-.091.02c-.029-.012-.042-.042-.058-.066-.013-.027-.041-.047-.046-.077.015-.023.049-.023.073-.022l.007.001h0ZM19.183 14.859c.033.005.054.034.07.06l.053.082c-.014.025-.047.034-.074.028-.03-.005-.05-.03-.064-.054-.013-.029-.037-.05-.052-.077-.01-.029.029-.037.05-.037l.017-.002ZM19.371 14.813h.013c0 .01.01.017.017.022.032.021.057.05.088.072.01.013.019.026.025.04-.029.026-.075.038-.107.013-.03-.023-.048-.059-.078-.082-.017-.011-.03-.043-.006-.053a.24.24 0 0 1 .048-.012Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.288 14.837c.008 0 .015.002.022.005-.002.013.008.029.019.036.028.021.045.053.07.076l.019.03c-.027.024-.071.033-.102.011-.031-.021-.042-.06-.066-.087-.01-.015-.032-.034-.022-.052.012-.015.032-.017.049-.018a.056.056 0 0 1 .011 0ZM19.436 14.775c0 .01.012.016.021.02.037.015.067.04.103.055a.07.07 0 0 0 .015.005h0l.015.015c.004.006.018.013.009.02-.051.061-.075.041-.108.02-.033-.023-.058-.053-.09-.075-.01-.007-.025-.019-.015-.032.009-.013.024-.019.038-.024a.06.06 0 0 1 .012-.004ZM18.375 14.984c.038-.007.076.018.094.05.021.031.04.064.06.096.01.015-.004.029-.019.031a.088.088 0 0 1-.1-.04c-.02-.03-.037-.062-.057-.092-.009-.01-.022-.036-.002-.042l.024-.003ZM18.248 14.99a.104.104 0 0 1 .094.03c.027.038.05.079.076.117.01.013 0 .032-.016.031a.09.09 0 0 1-.099-.035c-.02-.03-.035-.063-.058-.091-.013-.013-.027-.042-.004-.052h.006ZM18.494 14.976c.04-.007.074.022.092.054l.062.099c-.025.03-.074.03-.104.007-.027-.02-.039-.053-.057-.08-.013-.02-.027-.04-.038-.061.005-.02.03-.017.045-.02ZM18.724 14.947c.033-.006.062.019.079.045.018.03.038.057.055.087.004.01.011.022-.002.028a.08.08 0 0 1-.103-.012c-.025-.027-.037-.063-.061-.09-.014-.014-.028-.045-.001-.053.01-.004.022-.005.033-.005Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M18.61 14.963c.038-.006.072.024.089.057l.059.094c-.02.023-.052.029-.08.02-.034-.01-.052-.043-.068-.072-.014-.028-.042-.048-.046-.079-.001-.02.032-.017.045-.02ZM18.856 14.928c.04.008.059.048.08.079.014.022.03.044.04.068a.077.077 0 0 1-.094.015c-.033-.019-.046-.057-.067-.086-.013-.017-.042-.044-.022-.065.018-.011.043-.011.063-.01ZM17.815 15.082a.068.068 0 0 1-.013.016l-.014.013c.022-.019.036-.02.038.024a.24.24 0 0 1 0 .042l.012-.001c.015 0 .027-.016.018-.03-.014-.02-.028-.042-.04-.064ZM17.818 14.991h-.005c.005.006.007.016.008.033.001.027.002.042-.003.054l.03.051c.02.034.06.054.1.048.02.003.03-.022.017-.037-.024-.031-.04-.068-.063-.1a.102.102 0 0 0-.084-.049ZM18.032 14.992a.104.104 0 0 1 .101.057c.02.03.037.063.06.093.007.01.01.032-.01.032a.093.093 0 0 1-.084-.016c-.027-.024-.041-.058-.06-.088-.011-.023-.04-.04-.035-.068.004-.012.018-.01.028-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.912 14.993c.03-.006.06.003.083.023.025.026.04.06.06.091.009.02.027.035.029.056-.005.018-.03.013-.044.015-.04 0-.07-.029-.088-.062-.017-.032-.039-.062-.058-.092-.008-.014-.002-.034.018-.03ZM18.145 14.991c.035-.002.074.012.093.043.023.036.044.074.069.108.014.019-.01.037-.028.033a.089.089 0 0 1-.089-.042c-.022-.03-.038-.065-.06-.095-.011-.011-.023-.037-.003-.045.006-.002.012-.001.018-.002ZM19.475 14.732a.054.054 0 0 0 .02.009c.037.009.096.036.133.045l.015.002.008.005c.004.005.02.01.012.018-.034.065-.037.063-.102.04-.037-.016-.067-.04-.103-.056-.012-.005-.028-.014-.02-.029.005-.014.02-.022.032-.03l.005-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m19.505 14.68.005.001c.037.004.095.021.132.025.008.001.015 0 .02-.002.01.005.024.007.022.033-.008.04-.017.059-.056.05-.038-.01-.096-.037-.134-.046-.012-.003-.03-.01-.024-.025a.058.058 0 0 1 .021-.034c.003-.002.012 0 .014-.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.504 14.622c.007.005.016.006.031.007.04.003.069.01.107.006.004-.002.024 0 .035-.01.006.004.014.025.01.034-.004.036-.007.051-.045.047-.037-.004-.095-.021-.131-.025-.012-.001-.03-.005-.026-.02a.076.076 0 0 1 .019-.039Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.657 14.55c.014.007.022.022.027.056 0 .033-.036.027-.042.03-.038.003-.068-.004-.106-.007-.029-.002-.036-.002-.048-.03a.068.068 0 0 1-.005-.032c.009.007.018.006.037.005.04-.003.07-.001.106-.01.004-.003.021-.003.031-.013Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.635 14.478c.011.007.02.02.028.048.006.032-.03.032-.037.036-.037.009-.067.007-.106.01-.028.002-.035.004-.05-.022a.086.086 0 0 1-.013-.045c.013.013.021.01.044.007.039-.007.07-.008.105-.02.004-.003.02-.005.029-.014Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.62 14.418a.129.129 0 0 1 .02.035c.008.032-.029.034-.034.039-.036.012-.066.013-.105.02-.028.004-.034.007-.053-.017a.058.058 0 0 1-.01-.02c.008.006.017.007.034 0 .032-.012.096-.038.13-.048a.055.055 0 0 0 .018-.009ZM19.493 14.239c.02.002.033.02.047.038.01.016-.01.029-.023.032-.031.011-.096.045-.126.057-.027.014-.033-.003-.05-.026a.06.06 0 0 1-.01-.026c.008.005.016.006.03-.002.029-.015.09-.054.12-.067a.052.052 0 0 0 .012-.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.594 14.35c.014.007.02.026.033.044.01.017-.013.03-.026.033-.034.01-.097.036-.13.047-.03.014-.036.001-.056-.024a.086.086 0 0 1-.012-.018c.009.005.018.005.033-.003.033-.014.097-.043.13-.055.012-.003.027-.012.028-.024Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.545 14.293c.022 0 .03.024.048.047.01.016-.012.03-.026.034-.033.012-.097.041-.13.055-.029.015-.036.003-.058-.022-.009-.01-.023-.028-.012-.037.006.002.014.002.024-.004.03-.012.095-.046.126-.057a.043.043 0 0 0 .024-.016h.004ZM19.45 14.177c.02 0 .03.023.047.041.011.015-.003.022-.015.027-.03.013-.092.052-.122.067-.025.016-.033 0-.052-.022a.067.067 0 0 1-.01-.02.038.038 0 0 0 .014-.007c.027-.017.078-.053.107-.069a.052.052 0 0 0 .01-.008c.006-.001.016-.01.02-.01Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.387 14.13c.018 0 .033.014.049.03.012.012-.006.028-.017.034-.029.015-.08.052-.107.069-.024.017-.033.002-.052-.017l-.003-.004.002-.001c.029-.017.078-.062.108-.077.011-.005.028-.02.02-.034Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.336 14.096c.019.001.034.016.05.032.011.014-.007.03-.02.036-.029.015-.078.06-.107.077a.04.04 0 0 1-.013.006c-.01-.006-.018-.01-.035-.023l-.009-.009c.005 0 .01-.003.017-.009.027-.02.071-.07.098-.089a.043.043 0 0 0 .02-.021Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.28 14.053c.018 0 .035.013.052.027.014.012-.003.03-.015.037-.027.019-.071.07-.098.09a.033.033 0 0 1-.017.008.307.307 0 0 1-.028-.027c.024-.024.062-.076.086-.097.01-.007.024-.025.013-.037h.006Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.22 14.03c.017 0 .034.01.05.022.015.011 0 .031-.01.039-.025.02-.062.073-.087.097a.288.288 0 0 1-.024-.034c.02-.027.044-.065.061-.082.01-.01.023-.03.008-.04h-.002l.004-.001Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.173 14.015c.015 0 .03.008.046.017.015.01.002.03-.008.04-.017.017-.04.055-.06.082a.284.284 0 0 1-.026-.05.353.353 0 0 1 .03-.043c.01-.01.021-.031.005-.04l-.006-.002a.04.04 0 0 1 .019-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M19.116 14.007c.014 0 .029.007.043.014.017.009.005.03-.004.04a.352.352 0 0 0-.03.044.289.289 0 0 1-.02-.097.043.043 0 0 1 .011-.001ZM17.698 12.396a.047.047 0 0 1-.01.019v.005c.01-.004.017.005.018.035.002.043.005.054-.017.074l-.001.002v.003c.007-.003.014-.008.024-.02.029-.034.032-.04.015-.07l-.029-.048h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.707 12.238a.026.026 0 0 0-.01.003c0 .028 0 .042-.011.056v.01c.008 0 .014.01.015.037a.138.138 0 0 1-.003.053l.021.036c.016.026.031.036.06.002.029-.034.033-.04.015-.07l-.064-.11c-.007-.01-.014-.017-.023-.017h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.847 12.355c.029-.033.033-.039.015-.069a17.205 17.205 0 0 0-.065-.11c-.013-.021-.028-.026-.055.005-.025.03-.033.038-.02.06l.065.112c.016.027.03.036.06.002ZM17.966 12.126c.001.005.002.01.001.014-.028.008-.057-.006-.08-.025a.17.17 0 0 1-.015-.015v.001l-.004.001.055.093c.016.026.03.036.06.002a.153.153 0 0 0 .022-.031.096.096 0 0 1-.034-.033l-.005-.007Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m17.813 12.099-.003.003c-.025.03-.033.038-.02.06l.065.112c.016.027.03.037.06.003.029-.034.033-.04.015-.07l-.062-.104a.083.083 0 0 1-.055-.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.595 15.968a.099.099 0 1 0 0-.197.099.099 0 0 0 0 .197Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.525 15.94c-.067.037-.09.13-.09.242l.001.037c.04-.04.09-.063.157-.063s.119.023.158.062a.386.386 0 0 0 .002-.037c0-.11-.024-.205-.09-.241a.101.101 0 0 1-.07.028.1.1 0 0 1-.068-.028Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.594 16.156c-.334 0-.28.587-.28.775h.002a.035.035 0 0 1-.002-.004c0-.02.03-.038.082-.052a.827.827 0 0 1 .198-.021c.069 0 .135.006.187.018.05.012.084.029.091.047h.002c0-.189.054-.763-.28-.763h0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.595 17c.154 0 .28-.033.28-.073 0-.04-.126-.073-.28-.073-.155 0-.28.033-.28.073 0 .04.125.073.28.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.446 16.865c0-.215 0-.304.024-.391M17.366 16.885c0-.089-.006-.24.005-.318"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD242B",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M17.668 15.682h-.002l-.004.004a20.532 20.532 0 0 1-.13.1l-.005.011a.096.096 0 0 1 .067-.026c.037 0 .07.02.087.052.006-.02.003-.052.003-.104 0-.027-.006-.037-.016-.037Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVa;